import ShapeType from '@/enums/ShapeType';

export default {
  state: {
    shapeList: [],
    globalTable: {
      ajustementSurface: 0,
      ajustementSolive: 0,
    },
    shapeId: 0,
  },
  getters: {
    getShapeList: state => state.shapeList,
    getShapelistHasValue: state => state.shapeList.length > 0,
    getShape: state => index => state.shapeList.find(x => x.id === index),
    getShapeId: state => state.shapeId,
    getSurfaceReelle: (state, getters) => index => {
      const shape = getters.getShape(index);
      return parseFloat(shape.largeur) * parseFloat(shape.longueur);
    },
    getSurfaceTotal: (state, getters) => index => {
      const shape = getters.getShape(index);
      return parseFloat(shape.ajustement) + getters.getSurfaceReelle(index);
    },
    getSolives: (state, getters) => index => {
      const shape = getters.getShape(index);
      return (Math.round((parseFloat(shape.largeur) * 12) / 16) + 1) * parseFloat(shape.longueur) + 10;
    },
    getPerimetre: (state, getters) => index => {
      const shape = getters.getShape(index);
      return parseFloat(shape.longueur) * 2 + parseFloat(shape.largeur) * 2;
    },
    getParapet: (state, getters) => index => {
      const shape = getters.getShape(index);
      return parseFloat(shape.longueur) * 2 + parseFloat(shape.largeur) * 2;
    },
    getIsolationEntretoit: (state, getters) => index => {
      const shape = getters.getShape(index);
      return parseFloat(shape.largeur) * parseFloat(shape.longueur);
    },
    getSolin: (state, getters) => index => {
      const shape = getters.getShape(index);
      return parseFloat(shape.solin);
    },
    getContreSolin: (state, getters) => index => {
      const shape = getters.getShape(index);
      return parseFloat(shape.contreSolin);
    },
    getSommePerimetre: (state, getters) => {
      const reducer = (acc, vc) => acc + getters.getPerimetre(vc.id);
      return state.shapeList.reduce(reducer, 0);
    },
    getSommeSurface: (state, getters) => {
      const reducer = (acc, vc) => acc + getters.getSurfaceTotal(vc.id);
      return state.shapeList.reduce(reducer, 0) + parseFloat(state.globalTable.ajustementSurface);
    },
    getSommeSolives: (state, getters) => {
      const reducer = (acc, vc) => acc + getters.getSolives(vc.id);
      return state.shapeList.reduce(reducer, 0) + parseFloat(state.globalTable.ajustementSolive);
    },
    getSommeParapet: (state, getters) => {
      const reducer = (acc, vc) => acc + getters.getParapet(vc.id);
      return state.shapeList.reduce(reducer, 0);
    },
    getSommeIsolationEntretoit: (state, getters) => {
      const reducer = (acc, vc) => acc + getters.getIsolationEntretoit(vc.id);
      return state.shapeList.reduce(reducer, 0);
    },
    getSommeSolins: (state, getters) => {
      const reducer = (acc, vc) => acc + getters.getSolin(vc.id);
      return state.shapeList.reduce(reducer, 0);
    },
    getSommeContreSolins: (state, getters) => {
      const reducer = (acc, vc) => acc + getters.getContreSolin(vc.id);
      return state.shapeList.reduce(reducer, 0);
    },
    getSerializedData: state => JSON.stringify(state),
    mapToTaskObj: (state, getters) => ({
      id: 131,
      referenceName: 'ToitPlat',
      isFloorMeasurement: false,
      totals: {
        plat_surface_totale: getters.getSommeSurface,
        plat_perimetre_total: getters.getSommePerimetre,
        plat_solins_lo: getters.getSommeSolins,
        plat_contresolins_lo: getters.getSommeContreSolins,
        plat_parapet_lo: getters.getSommeParapet,
        plat_solives: getters.getSommeSolives,
      },
      measures: getters.getSerializedData,
    }),
  },
  mutations: {
    pushShape: (state, id) => {
      const rawShape = ShapeType.ShapeTypes[3].getNewShape();
      rawShape.id = id;
      state.shapeList.push(rawShape);
    },
    pushState: (state, payload) => {
      const tempState = JSON.parse(payload);
      state.shapeList = tempState.shapeList;
      state.globalTable = tempState.globalTable;
      state.shapeId = tempState.shapeId;
    },
    removeShape: (state, id) => {
      state.shapeList = state.shapeList.filter(x => x.id !== id);
    },
    incrementShapeId: state => {
      state.shapeId++;
    },
    resetState: state => {
      state.shapeList = [];
      state.shapeId = 0;

      state.globalTable = {
        ajustementSurface: 0,
        ajustementSolive: 0,
      };
    },
  },
  actions: {
    addShape({ commit, getters }) {
      commit('pushShape', getters.getShapeId);
      commit('incrementShapeId');
    },
  },
};
